module.exports = __webpack_public_path__ + "img/badge_gray_adv-ccr.5c351e39.svg";